(function () {
    'use strict';
    angular.module('app').controller('thirdPartyCredentialsRemovalConfirmationController', ['$uibModalInstance', 'args', thirdPartyCredentialsRemovalConfirmationController]);

    function thirdPartyCredentialsRemovalConfirmationController($uibModalInstance, args) {

        var vm = this;
        vm.name = args.credentials.name;
        vm.confirm = confirm;
        vm.cancel = cancel;

        function confirm() {
            $uibModalInstance.close();
        }

        function cancel() {
          $uibModalInstance.dismiss('cancel');
        }
    }
})();